<template>
  <!-- <el-timeline-item> -->
    <div class="timeline-item-body">
      <div class="item-timestamp text-notwarp">{{item.timestamp | diff}}</div>
      <!-- <div class="item-timestamp1 text-notwarp" >{{item.belong_type?'设备':'回路'}}</div> -->
      <div class="line" v-if="item.event_name=='过流'"><img src="../../../assets/img/tips.png" alt=""></div>
      <div class="line" v-else-if="item.event_name=='高温'"><img src="../../../assets/img/error-red.png" alt=""></div>
      <div class="line" v-else><img src="../../../assets/img/error-green.png" alt=""></div>
      <div class="item-loop text-notwarp">{{item.loop}}</div>
      <!-- <div class="item-type text-notwarp">{{item.type | mapper}}</div> -->
      <div class="item-description text-notwarp">{{item.event_name}}</div>
      <div class="item-detail" @click="$emit('showDetail', item.code)">详情</div>
    </div>
  <!-- </el-timeline-item> -->

</template>
<script>
import dateTimeStamp from '../../../util/DateDiff';
const TYPES = {
  TELEMETRY_OVERRUN: '越限异常',
  EQUIPMENT_FAILURE: '网关离线',
  TELEMETRY_DISPLACEMENT: '跳闸报警',
//   DEVICE_EXCEPTION: '设备异常',
     DEVICE_FAILURE: '设备异常',
}


export default {
  props: {
    item: Object,
  },
  filters: {
    diff: function(value) {   
        // console.log(value)   
      return dateTimeStamp(Date.parse(value));
    },
    mapper: function(value) {
      return TYPES[value] || '未知事件';
    }
  }
};
</script>

<style lang="less" scoped>
.line{
  position: relative;
  &::before{
    content: '';
    border-left: 1px solid #E5E5E5;
    position: absolute;
    height: 100%;
    left: 50%;
    top: 0;
  }
  img{
    width: 16px;
    height: 16px;
    position: relative;
    z-index: 222;
  }
}
.timeline-item-body {
  // display: flex;
  // justify-content: space-between;
  height: 60rem;
  line-height: 18px;
  div{
    display: inline-block;
    height: 60rem;
    float: left;
  }
  .text-notwarp {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    align-items: center;
    // background: cornflowerblue;
  }

  .item-timestamp {
    width: 150px;
    // font-size: 18rem;
    font-weight: 400;
    color: #999999;
    text-align: right;
    padding-right: 12px;
  }
 .item-timestamp1 {
    // width: 10%;
    font-size: 18rem;
    font-weight: 400;
    color: #666666;
text-align: center;
}
  .item-loop {
    // width: 20%;
    margin-right: 12px;
    padding-left: 12px;
    font-size: 18rem;
    font-weight: 400;
    color: #0d94ff;
  }

  .item-type {
    // width: 15%;
    font-size: 18rem;
    font-weight: 400;
    color: #0d94ff;
  }

  .item-description {
    // width: 30%;
    font-size: 18rem;
    font-weight: 400;
    // color: #666666;
  }

  .item-detail {
    width: 10%;
    text-align: center;
    font-size: 18rem;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
    float: right;
  }
}
</style>